(function () {
  function getCount() { var el = document.getElementById('hc-product-count'); return el ? el.getAttribute('data-count') : null; }

  function moveSort() {
    var sel = document.getElementById('SortBy');
    var form = document.querySelector('#CollectionSidebar .filter-form');
    if (!sel || !form) return;
    var cell = sel.closest('.grid__item') || sel.parentElement;
    if (cell && cell.parentElement !== form) { cell.classList.add('hc-sort-cell'); form.appendChild(cell); }
    var lbl = form.querySelector('.hc-sort-cell label[for="SortBy"]');
    if (lbl && lbl.textContent.trim() !== 'Sort') lbl.textContent = 'Sort';
  }

  function showSelections() {
    var sb = document.getElementById('CollectionSidebar'); if (!sb) return;
    [].forEach.call(sb.querySelectorAll('.collection-sidebar__group'), function (g) {
      var trig = g.querySelector('.collapsible-trigger-btn'); if (!trig) return;
      var vals = [];
      [].forEach.call(g.querySelectorAll('input:checked'), function (cb) {
        var lbl = cb.closest('label') || cb.parentElement;
        var t = (lbl.textContent || '').replace(/\(\d[\d,]*\)/, '').replace(/\s+/g, ' ').trim();
        if (t) vals.push(t);
      });
      var gte = g.querySelector('input[name*="price.gte"]'), lte = g.querySelector('input[name*="price.lte"]');
      var price = ((gte && gte.value) || (lte && lte.value)) ? '$' + ((gte && gte.value) || '0') + '–$' + ((lte && lte.value) || '∞') : null;
      var count = vals.length + (price ? 1 : 0);
      var span = trig.querySelector('.hc-selected');
      if (count === 0) { if (span) span.parentNode.removeChild(span); return; }
      if (!span) { span = document.createElement('span'); span.className = 'hc-selected'; var icon = trig.querySelector('.collapsible-trigger__icon'); if (icon) trig.insertBefore(span, icon); else trig.appendChild(span); }
      var mode = count === 1 ? 'text' : 'count';
      var text = count === 1 ? (vals[0] || price) : String(count);
      if (span.getAttribute('data-mode') !== mode || span.textContent !== text) { span.setAttribute('data-mode', mode); span.className = 'hc-selected ' + (mode === 'count' ? 'hc-selected--count' : 'hc-selected--text'); span.textContent = text; }
    });
  }

  function ensureDesktopCount() {
    var form = document.querySelector('#CollectionSidebar .filter-form'); if (!form) return;
    var n = getCount();
    var el = document.getElementById('hc-desktop-count');
    if (n == null) { if (el) el.remove(); form.classList.remove('hc-has-count'); return; }
    if (!el) { el = document.createElement('span'); el.id = 'hc-desktop-count'; el.className = 'hc-desktop-count'; var sc = form.querySelector('.hc-sort-cell'); if (sc) form.insertBefore(el, sc); else form.appendChild(el); }
    form.classList.add('hc-has-count');
    var txt = n + ' ' + (n === '1' ? 'item' : 'items');
    if (el.textContent !== txt) el.textContent = txt;
  }

  function ensureViewResults() {
    var drawer = document.getElementById('FilterDrawer'); if (!drawer) return;
    var contents = drawer.querySelector('.drawer__contents'); if (!contents) return;
    var btn = document.getElementById('hc-view-results');
    if (!btn) { btn = document.createElement('button'); btn.id = 'hc-view-results'; btn.type = 'button'; btn.addEventListener('click', function () { var c = drawer.querySelector('.js-drawer-close'); if (c) c.click(); }); }
    if (btn.parentElement !== contents) contents.appendChild(btn);
    var n = getCount();
    btn.textContent = (n != null) ? ('See ' + n + ' ' + (n === '1' ? 'Item' : 'Items')) : 'View Results';
  }

  function apply() { moveSort(); showSelections(); ensureDesktopCount(); ensureViewResults(); }

  var raf = null;
  function sched() { if (raf) return; raf = requestAnimationFrame(function () { raf = null; apply(); }); }

  function init() { apply(); if (!window.__hcObs) { window.__hcObs = new MutationObserver(sched); window.__hcObs.observe(document.body, { childList: true, subtree: true }); } }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);

  // Desktop: one dropdown open at a time + click-outside to close
  if (!window.__hcFilterBound) {
    window.__hcFilterBound = true;
    var desk = function () { return matchMedia('(min-width:769px)').matches; };
    var sb = function () { return document.getElementById('CollectionSidebar'); };
    var lock = false, lastTrig = null;
    document.addEventListener('click', function (e) {
      var b = sb(); if (!b) return;
      var trig = e.target.closest('.collapsible-trigger-btn');
      if (trig && b.contains(trig)) {
        if (!desk() || lock) return;
        lastTrig = trig;
        setTimeout(function () { if (lock) return; if (lastTrig && lastTrig.classList.contains('is-open')) { lock = true; b.querySelectorAll('.collapsible-trigger-btn.is-open').forEach(function (t) { if (t !== lastTrig) t.click(); }); lock = false; } }, 0);
        return;
      }
      if (desk() && !b.contains(e.target)) { var open = b.querySelectorAll('.collapsible-trigger-btn.is-open'); if (open.length) { lock = true; open.forEach(function (t) { t.click(); }); lock = false; } }
    }, true);
  }

  // Mobile: expand all sections when the drawer opens
  if (!window.__hcExpandBound) {
    window.__hcExpandBound = true;
    document.addEventListener('click', function (e) {
      if (e.target.closest('#FilterDrawerTrigger')) {
        setTimeout(function () { if (matchMedia('(max-width:768px)').matches) { document.querySelectorAll('#FilterDrawer .collapsible-trigger-btn:not(.is-open)').forEach(function (t) { t.click(); }); } }, 80);
      }
    }, true);
  }

  // Close any open desktop dropdowns when crossing from mobile to desktop width
  if (!window.__hcResizeBound) {
    window.__hcResizeBound = true;
    var wasDesk = matchMedia('(min-width:769px)').matches;
    window.addEventListener('resize', function () {
      var isDesk = matchMedia('(min-width:769px)').matches;
      if (isDesk && !wasDesk) { document.querySelectorAll('#CollectionSidebar .collapsible-trigger-btn.is-open').forEach(function (t) { t.click(); }); }
      wasDesk = isDesk;
    });
  }
})();